var moduleMap = {
	"./ProcessManager": () => {
		return __webpack_require__.e(4816).then(() => (() => ((__webpack_require__(84816)))));
	},
	"./ppPrivateFetcher": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(1437), __webpack_require__.e(561), __webpack_require__.e(8960), __webpack_require__.e(6661), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(6240)]).then(() => (() => ((__webpack_require__(99146)))));
	},
	"./appStateManager": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(1437), __webpack_require__.e(561), __webpack_require__.e(8960), __webpack_require__.e(6661), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(4817)]).then(() => (() => ((__webpack_require__(46760)))));
	},
	"./ppUserAccountService": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(1437), __webpack_require__.e(561), __webpack_require__.e(8960), __webpack_require__.e(6661), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(350)]).then(() => (() => ((__webpack_require__(19526)))));
	},
	"./ppAppEndpointsConfig": () => {
		return Promise.all([__webpack_require__.e(1858), __webpack_require__.e(8565)]).then(() => (() => ((__webpack_require__(28565)))));
	},
	"./fetchers/ppWebhook": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(1437), __webpack_require__.e(561), __webpack_require__.e(8960), __webpack_require__.e(6661), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(477)]).then(() => (() => ((__webpack_require__(4021)))));
	},
	"./fetchers/ppPrivateFetcher": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(1437), __webpack_require__.e(561), __webpack_require__.e(8960), __webpack_require__.e(6661), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(6240)]).then(() => (() => ((__webpack_require__(99146)))));
	},
	"./fetchers/ppCustomNotification": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(1437), __webpack_require__.e(561), __webpack_require__.e(8960), __webpack_require__.e(8649), __webpack_require__.e(6661), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(1648), __webpack_require__.e(4034)]).then(() => (() => ((__webpack_require__(82922)))));
	},
	"./fetchers/ppTrackingWidgetFetcher": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(1437), __webpack_require__.e(561), __webpack_require__.e(8960), __webpack_require__.e(6661), __webpack_require__.e(1858), __webpack_require__.e(3969), __webpack_require__.e(3982)]).then(() => (() => ((__webpack_require__(55906)))));
	},
	"./constants/productExperience.constant": () => {
		return __webpack_require__.e(1386).then(() => (() => ((__webpack_require__(21386)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});